__turbopack_context__.v({
  "root": "EcomFeaturesShowcase-module__UtJm2W__root",
});
